import { useContext, } from 'react';
import { Field, Panel } from '../../../../layouts';
import { PurchaseOrderContext } from '../../purchase-order/context/PurchaseOrderContext';

export default function CreditMemoShipToPanel() {

	const { order } = useContext(PurchaseOrderContext);

	return (
		<>
			<Panel
				header={'Ship To'}
				className="field-label-30"
			>
				<Field label={'Company'} >{order.details.cfi.companyName}</Field>
				<Field label={'Address'} >{order.details.cfi.PA_Address1}</Field>
				<Field label={''} visible={!!order.details.cfi.PA_Address2}>{order.details.cfi.PA_Address2}</Field>
				<Field label={'City'} >{order.details.cfi.PA_City}, {order.details.cfi.PA_State} {order.details.cfi.PA_Zip}</Field>
			</Panel>
		</>
	);
}
